import { render, staticRenderFns } from "./BulkOperation.vue?vue&type=template&id=21a0c9a0&scoped=true"
import script from "./BulkOperation.vue?vue&type=script&lang=js"
export * from "./BulkOperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a0c9a0",
  null
  
)

export default component.exports